import { Sort as EBackendSort } from '../../types/apollo';
import { Sidebar } from '../../../features/search-filters/models/sidebar';

export type ISortOptions = {
  id: Sidebar.ESort;
  title: string;
  orderType?: Sidebar.EOrder;
  backendType?: EBackendSort;
};

export const sortTitles = {
  'default': 'Популярные',
  'price_asc': 'Подешевле',
  'price_desc': 'Подороже',
  'rating': 'Высокий рейтинг',
  'orders': 'Много заказов',
  'date': 'Добавлены недавно',
};

export function getSortOptionTitle(sorting: Sidebar.ESort, ordering: Sidebar.EOrder): string {
  return sortOptions.find((option) => option.id === sorting && option.orderType === ordering)?.title || sortTitles.default;
}

export const sortOptions: ISortOptions[] = [
  {
    id: Sidebar.ESort.default,
    title: sortTitles.default,
    orderType: Sidebar.EOrder.default,
    backendType: EBackendSort.BY_RELEVANCE_DESC,
  },
  {
    id: Sidebar.ESort.price,
    title: sortTitles.price_asc,
    orderType: Sidebar.EOrder.ascending,
    backendType: EBackendSort.BY_PRICE_ASC,
  },
  {
    id: Sidebar.ESort.price,
    title: sortTitles.price_desc,
    orderType: Sidebar.EOrder.descending,
    backendType: EBackendSort.BY_PRICE_DESC,
  },
  {
    id: Sidebar.ESort.rating,
    title: sortTitles.rating,
    orderType: Sidebar.EOrder.descending,
    backendType: EBackendSort.BY_RATING_DESC,
  },
  {
    id: Sidebar.ESort.orders,
    title: sortTitles.orders,
    orderType: Sidebar.EOrder.descending,
    backendType: EBackendSort.BY_ORDERS_NUMBER_DESC,
  },
  {
    id: Sidebar.ESort.date,
    title: sortTitles.date,
    orderType: Sidebar.EOrder.descending,
    backendType: EBackendSort.BY_DATE_ADDED_DESC,
  },
];

export function getBackendType(
  sorting: Sidebar.ESort = Sidebar.ESort.default,
  ordering: Sidebar.EOrder = Sidebar.EOrder.default,
): EBackendSort {
  // @ts-ignore 
  return sortOptions.find((option) => {
    if (!sorting) {
      return sortOptions[0];
    }

    return option.id === sorting && option.orderType === ordering;
  })?.backendType;
}

export function findCurrentOptionIndex(sorting: Sidebar.ESort, ordering: Sidebar.EOrder): number {
  let currentSortIdx = sortOptions.findIndex((s) => s.id === sorting && s.orderType === ordering);
  if (currentSortIdx === -1) currentSortIdx = 0;

  return currentSortIdx;
}
